
export default {
  name: 'FInfoIcon',

  props: {
    on: {
      type: Object,
      default: () => ({}),
    },

    tooltipIconClass: {
      type: String,
      default: '',
    },

    hasError: {
      type: Boolean,
    },
  },
};
